import { CommonMutationCrumbs } from './breadcrumb';

export const SearchPersonMarriageCrumbs = [
  ...CommonMutationCrumbs,
  {
    name: 'Ricerca persona - Registrazione Matrimonio',
    path: '/mutazioni/persona/matrimonio/residenti',
  },
];

export const RegistrationMarriageCrumbs = [
  ...SearchPersonMarriageCrumbs,
  {
    name: 'Registrazione Matrimonio',
    path: '/mutazioni/persona/matrimonio/residenti/registrazione',
  },
];
